import { SectionBlockMediaFeatured } from "../sections/blocks/SectionBlockMediaFeatured";
import { HeroPrimary } from "../headers/HeroPrimary";
import { WrapperComponents } from "../wrappers/WrapperComponents";
import { SectionBlockTextColumns } from "../sections/blocks/SectionBlockTextColumns";
import { SectionBlockPinnedMediaItems } from "../sections/blocks/SectionBlockPinnedMediaItems";
import { SectionBlockMediaItem } from "../sections/blocks/SectionBlockMediaItem";
import { SectionGridColumns } from "../sections/grids/SectionGridColumns";
import { CardIconContent } from "../components/cards/CardIconContent";
import { CardCarousel } from "../components/cards/CardCarousel";
import { SectionCardCarousel } from "../sections/blocks/SectionCardCarousel";
import { SectionBlockMap } from "../sections/blocks/SectionBlockMap";

export interface ITemplateTheMatesProgram {
  data: any;
}

export default function TemplateTheMatesProgram({
  data,
}: ITemplateTheMatesProgram) {
  const {
    heroPrimary,
    sectionBlockTextColumns,
    sectionBlockPinnedMediaItems,
    sectionGridThreeCards,
    callToAction,
    featuredImage,
    sectionBlockCardCarousel,
    sectionBlockMap,
  } = data;

  // console.log("templateTheMatesProgram", data);

  return (
    <>
      {heroPrimary && <HeroPrimary data={heroPrimary} />}
      <WrapperComponents>
        {sectionBlockTextColumns && (
          <SectionBlockTextColumns data={sectionBlockTextColumns} />
        )}

        {sectionBlockCardCarousel &&
          sectionBlockCardCarousel.items.length > 0 && (
            <SectionCardCarousel
              theme="colour"
              data={{
                text: sectionBlockCardCarousel.text,
                title: sectionBlockCardCarousel.title,
                link: sectionBlockCardCarousel.link,
              }}
            >
              {Array.isArray(sectionBlockCardCarousel.items) &&
                sectionBlockCardCarousel.items.map(
                  (item: any, index: number) => (
                    <CardCarousel
                      theme="light"
                      heightFull
                      card={{
                        title: item.title,
                        text: item.text,
                      }}
                      key={index}
                      index={index + 1}
                    />
                  ),
                )}
            </SectionCardCarousel>
          )}

        {sectionBlockPinnedMediaItems && (
          <SectionBlockPinnedMediaItems data={sectionBlockPinnedMediaItems} />
        )}

        {sectionBlockMap && <SectionBlockMap data={sectionBlockMap} />}

        {sectionGridThreeCards && sectionGridThreeCards.cards && (
          <SectionGridColumns
            title={sectionGridThreeCards.title}
            subtitle={sectionGridThreeCards.subtitle}
          >
            {sectionGridThreeCards.cards &&
              sectionGridThreeCards.cards.map((card, index) => {
                return <CardIconContent key={index} card={card} />;
              })}
          </SectionGridColumns>
        )}

        {featuredImage && (
          <SectionBlockMediaFeatured
            data={{
              image: featuredImage,
            }}
          />
        )}

        {callToAction && <SectionBlockMediaItem data={callToAction} inverse />}
      </WrapperComponents>
    </>
  );
}
